import { Table } from '@scuf/common';
import usePreventClickjacking from 'helpers/hooks/usePreventingClickjacking';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function ContractsPage() {
    const { t } = useTranslation(['home', 'pages']);

    useEffect(() => {
        document.title = t('pages:contracts');
    }, []);

    usePreventClickjacking();

    return (
        <>
            <div className="container2">
                <div className="contentPageContainer2">
                    <div className="container-grande2">
                        <h4>{t('pages:contracts')}</h4>
                        <p>{t('home:contractsPage.text1')}</p>
                        <h4>{t('home:contractsPage.title2')}</h4>
                        <p>{t('home:contractsPage.text2')}</p>
                        <p>{t('home:contractsPage.text3')}</p>
                        <ul className="column">
                            <li>{t('home:contractsPage.l1')}</li>
                            <li>{t('home:contractsPage.l2')}</li>
                            <li>{t('home:contractsPage.l3')}</li>
                            <li>{t('home:contractsPage.l4')}</li>
                        </ul>
                        <p>{t('home:contractsPage.text4')}</p>
                        <h4>{t('home:contractsPage.title4')}</h4>
                        <ul className="column">
                            <li>{t('home:contractsPage.l5')}</li>
                            <li>{t('home:contractsPage.l6')}</li>
                            <li>{t('home:contractsPage.l7')}</li>
                            <li>{t('home:contractsPage.l8')}</li>
                        </ul>
                        <h4>{t('home:contractsPage.title5')}</h4>
                        <ul className="column">
                            <li>{t('home:contractsPage.l9')}</li>
                            <li>{t('home:contractsPage.l10')}</li>
                            <li>{t('home:contractsPage.l11')}</li>
                        </ul>
                        <h4>{t('home:contractsPage.title6')}</h4>
                        <ul className="column">
                            <li>{t('home:contractsPage.l12')}</li>
                            <li>{t('home:contractsPage.l13')}</li>
                        </ul>
                    </div>
                </div>
                <div className="contentPageContainer2">
                    <div className="container-grande2">
                        <h4>{t('home:contractsPage.title3')}</h4>
                        <Table>
                            <Table.Header>
                                <Table.HeaderCell content={t('common:translation.Description')} />
                                <Table.HeaderCell content={t('home:contractsPage.coberturaP')} />
                                <Table.HeaderCell content={t('home:contractsPage.CoberturaG')} />
                            </Table.Header>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell>{t('home:contractsPage.item1')} </Table.Cell>
                                    <Table.Cell>{t('home:contractsPage.day3')} </Table.Cell>
                                    <Table.Cell>{t('home:contractsPage.day5')} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('home:contractsPage.item2')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('home:contractsPage.item3')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'-'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('home:contractsPage.item4')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'-'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{<li>{t('home:contractsPage.item5')}</li>} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'-'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{<li>{t('home:contractsPage.item6')}</li>} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'-'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{<li>{t('home:contractsPage.item7')}</li>} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'-'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('home:contractsPage.item8')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('home:contractsPage.item9')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('home:contractsPage.item10')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('home:contractsPage.item11')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('home:contractsPage.item12')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'-'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('home:contractsPage.item13')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'-'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('home:contractsPage.item14')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'-'} </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ContractsPage;
